import logoutHandler from './logoutHandler';

export default logoutHandler;
